<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_document"
        title="Klagepositionen"
        @save="saveLawsuitData">
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Reparaturkosten"
                property="repairAmount"
                type="currency"/>

            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Geleistete Zahlungen"
                property="repairPaidAmount"
                type="currency"/>

            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Berechtigte Kürzung"
                property="repairReductionAmount"
                type="currency"
                @change="recalculateRepairRemainingAmount"/>

            <csp-desktop-info-card-element
                class="col-6"
                currency
                :form-context="formContext"
                label="Offene Forderung"
                property="repairRemainingAmount"
                type="currency"/>

            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Grund der Kürzung"
                property="repairReductionReason"
                type="text"/>
        </b-row>
        <hr>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Mietwagenkosten"
                property="rentalAmount"
                type="currency"/>

            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Geleistete Zahlungen"
                property="rentalPaidAmount"
                type="currency"/>

            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Berechtigte Kürzung"
                property="rentalReductionAmount"
                type="currency"
                @change="recalculateRentalRemainingAmount"/>

            <csp-desktop-info-card-element
                class="col-6"
                currency
                :form-context="formContext"
                label="Offene Forderung"
                property="rentalRemainingAmount"
                type="currency"/>

            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Grund der Kürzung"
                property="rentalReductionReason"
                type="text"/>
        </b-row>
        <hr>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Klage eingereicht am"
                property="lawsuitFiledDate"
                type="datepicker"/>

            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Gerichtstermin am"
                property="courtDate"
                type="datepicker"/>

            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Eingeklagte Position"
                property="claimedPosition"
                type="text"/>

            <csp-desktop-info-card-element
                class="col-6"
                currency
                :form-context="formContext"
                label="Klagebetrag"
                property="claimedAmount"
                type="currency"/>

            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Verkündungstermine bzw. Urteilsverkündung eingereicht am"
                property="judgmentDate"
                type="datepicker"/>

            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Abschluss des Verfahrens inkl. Verfahrensausgang"
                property="lawsuitOutcome"
                type="text"/>

            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Grund für Aktenabschluss"
                property="recordClosedReason"
                type="text"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import Container from '@services/Container';
    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'RecordLawsuit',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        methods: {
            saveLawsuitData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveLawsuitData(objectId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
            recalculateRentalRemainingAmount() {
                const amount = this.formContext.form.getProperty('rentalAmount');
                const paid = this.formContext.form.getProperty('rentalPaidAmount');
                const reduction = this.formContext.form.getProperty('rentalReductionAmount');
                this.formContext.form.setProperty('rentalRemainingAmount', amount - paid - reduction);
            },
            recalculateRepairRemainingAmount() {
                const amount = this.formContext.form.getProperty('repairAmount');
                const paid = this.formContext.form.getProperty('repairPaidAmount');
                const reduction = this.formContext.form.getProperty('repairReductionAmount');
                this.formContext.form.setProperty('repairRemainingAmount', amount - paid - reduction);
            },
        },
    };
</script>
